import { createFileRoute } from "@tanstack/react-router"
import { BoothConsole } from "@/features/live-events-admin/booth/BoothConsole"

export const Route = createFileRoute("/live-events/$eventId/booth")({
	component: BoothPage,
})

function BoothPage() {
	const { eventId } = Route.useParams()
	return <BoothConsole eventId={eventId} />
}
